import { Component, OnInit } from '@angular/core';
import { SessionRestore } from '@app/core/authentication/authentication.actions';
import { Store } from '@ngrx/store';
import { BaseComponent } from '@app/shared/components/base/base.component';

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent
                                implements OnInit {

  constructor(
      private store: Store<{user: object}>,
  ) {
    super();
  }

  public ngOnInit() {
    this.store.dispatch(new SessionRestore());
  }

}
